import { Injectable } from '@angular/core';

export enum TokenStorageKey {
    ACCESS_TOKEN = 'accessToken',
    FROM_QUERY = 'tokenFromQuery',
}

export enum HubStorageKey {
    BOOTSTRAP_AT = 'raadsHubBootstrapAt',
    AUTH_EPOCH = 'raadsHubAuthEpoch',
}

export enum ClientStorageKey {
    ACTIVE_ID = 'raadsActiveClienteId',
    TIMEZONE = 'timezone',
    TELEGRAM_INFO = 'telegramInfo',
    VTURB_API_KEY = 'vturb_api_key',
    FINANCIAL_DASHBOARD_VERSION = 'financialDashboardVersion',
}

export type AppStorageKey = TokenStorageKey | HubStorageKey | ClientStorageKey;

@Injectable({ providedIn: 'root' })
export class StorageService {
    getLocal(key: AppStorageKey): string | null {
        if (typeof localStorage === 'undefined') {
            return null;
        }
        return localStorage.getItem(key);
    }

    setLocal(key: AppStorageKey, value: string): void {
        localStorage.setItem(key, value);
    }

    removeLocal(key: AppStorageKey): void {
        localStorage.removeItem(key);
    }

    getSession(key: AppStorageKey): string | null {
        if (typeof sessionStorage === 'undefined') {
            return null;
        }
        return sessionStorage.getItem(key);
    }

    setSession(key: AppStorageKey, value: string): void {
        sessionStorage.setItem(key, value);
    }

    removeSession(key: AppStorageKey): void {
        sessionStorage.removeItem(key);
    }
}
